import {Link, useParams} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi, putApi/*, deleteApi*/, setTitle, consoleLog} from '../../utils/functions';
import {UserContext} from '../../utils/usercontext';
import EventEmitter from '../../utils/emmiter';
//import CopyBox from '../components/bbcode/copybox';

import UploadFile from '../components/upload/upload';
import Blocks from '../components/bbcode/blocks';
import Socials from '../components/socials/socials';

import Genres from '../components/genres/genres';
//import AudioBox from './components/audio/audiobox';
import moment from 'moment';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import '../components/fontawesome/fontawesome';
import VideoPlayer from '../components/video/video';
import AudioPlayer from '../components/video/audio';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

import PortalFollwers from './followers';

//import { Swiper, SwiperSlide } from 'swiper/react';
//import { Autoplay, Pagination, Navigation } from "swiper";
//import 'swiper/css';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
//import Button from 'react-bootstrap/Button';

import './css/profile.css';
//import './css/header.css';

class PortalProfile extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    
    this.state = {
      status: false,
      username: this.props.username,
			account: {},
      profile: {},
      portable: this.props.portable ? true : false,
      friends: 0,
      followers: 0,
      content: {
        schedule: [],
        published: [],
      },
		};
    this.changeAvatar = this.changeAvatar.bind(this);
    this.returnFollowers = this.returnFollowers.bind(this);
    this.length = this.length.bind(this);
    consoleLog(this.state);
  };

  async componentDidMount() {
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
    value.setTheme( getUser );
		//const y = await value.setWorker( this.props.service );
		//let server = value.worker[this.props.service] || y[this.props.service];

    let params = new URLSearchParams();
		params.append('username', this.state.username);
		const x = await postApi(`/v3/account/profile`, params);
    consoleLog(x.data);
    if( x.status === 200 ) {
      let title = x.data.account.title?x.data.account.title:x.data.account.username;
      setTitle(`${title.charAt(0).toUpperCase() + String(title).slice(1)} profile`);
      this.setState({status: true, account: x.data.account?x.data.account:{}, profile: x.data.profile?x.data.profile:{}, content: x.data.content});
    }

		EventEmitter.emit('/client', '');
		
		
		
	}

	componentWillUnmount() {
    
	}

  async changeAvatar(name) {
    //console.log("here:", name);
    //const user = this.context;
    //let description_temp = this.state.description_temp;
    //description_temp.avatar = name;
		//this.setState({description_temp});

    let params = new URLSearchParams();
    params.append('id', this.state.account.id);
    params.append('avatar', name);
    await putApi(`/v3/account/settings`, params);
	}

  returnFollowers(data) {
    this.setState({friends: data.friends, followers: data.followers});
  }


  length(length) {
		length /= 60;
		let hours = Math.floor(length / 60);
		let minutes = Math.floor(length % 60);
  	return hours===0?`${minutes} mins`:`${hours} hrs ${minutes} mins`;
	}
  
	render() {
    const user = this.context;

    let profile = Object.values(this.state.profile).filter(elem => elem === true);
		let profile_percent = profile.length / Object.values(this.state.profile).length * 100;

    const schedule = this.state.content.schedule.map((e,i)=>{
      return (
        <div key={i} className="card custom-card">
          <div className="d-flex align-items-center">
            <div className="px-2 profile-schedule-avatar">
              <img src={`https://cloud.ultrastream.io${e.useravatar}`} className="rounded-start" alt="DJ Avatar" />
            </div>
            <div>
              <div className="card-header">
                <div className="card-title">{e.title} - {e.showname} {moment(e.start).format("DD MMM YYYY")}</div>
              </div>
              <div className="card-body py-0">
                
                  
                  <div className="">
                    <h6 className="card-title fw-semibold">{e.djtitle ? e.djtitle : e.usertitle ? e.usertitle : e.username} {moment(e.start).format("h:mm A")} - {moment(e.end).format("h:mm A")}</h6>
                  </div>
                  {e.platforms.map((f,j)=>{
                    return (
                      <span className="avatar avatar-sm me-2">
                        {f.platform === 'audio' ?
                          <a href={f.website} target="_blank" rel="noreferrer" >
                            {e.avatar ?
                              <img src={f.avatar} width={42} alt="Platform Avatar" />
                            :
                              <FontAwesomeIcon icon={'headphones'} size="xl" />
                            }
                          </a>
                        :
                          <a href={f.website} target="_blank" rel="noreferrer" >
                            <img src={`https://cloud.ultrastream.io/images/platforms/${f.platform.toLowerCase()}.png`} alt="Platform Avatar" />
                          </a>
                        }
                      </span>
                    )
                  })}
                  
                  <div className="">
                        {/*f.platform}: <a href={f.website} target="_blank" rel="noreferrer" >{f.website}</a>*/}
                      </div>
                
              </div>
              <div className="card-footer">
                <p className="card-text"><small className="text-muted"><Genres genres={e.genres} /></small></p>
              </div>
            </div>
          </div>
        </div>
      )
    });


    const published = this.state.content.published.map((e,i)=>{
      return (
        <div key={i} className="card custom-card">
          <div className="d-md-flex align-items-center">
            <div className="px-2 profile-published-avatar">
              <img src={`https://${e.subdomain}/v3/service/replay/${e.service}/${e.id}/${e.filename.replace('.mp4','.png')}?d=${Math.floor(Date.now()/1000)}`} className="img-fluid rounded-start h-100 w-100" alt="..." crossOrigin="use-credentials" />
            </div>
            <div className="">
              <div className="card-header">
                <div className="card-title">{e.showname}</div>
              </div>
              <div className="card-body">
                <h6 className="card-title fw-semibold">Running Time: {this.length(e.length)}</h6>
                <p>
                  Mixcloud status if published to mixcloud<br />
                  Listen on Mixcloud, Facebook
                </p>
                {/*<p className="card-text">This is a wider card with supporting text below as a natural .</p>*/}
              </div>
            </div>
            </div>
              <div className="card-footer">

                <Swiper
                  spaceBetween={10}
                  breakpoints={{576: {slidesPerView: 1,},768: {slidesPerView: 2,},992: {slidesPerView: 3,},1200: {slidesPerView: 4,},1400: {slidesPerView: 5,}}}
                  modules={[Autoplay, Pagination, Navigation]}
                  navigation
                  pagination={{clickable: true}}
                  
                  autoplay={{delay: 5000, disableOnInteraction: false,}}
                >
                  {e.clips.map((f,j)=>{
                    return (
                      <SwiperSlide key={j} className="profile-swiper-slide">
                        <div className="">
                          {/*<Link to={`/${this.state.posters[e].username.replaceAll(' ','_')}`}><img src={`https://mix365.co.uk/${this.state.posters[e].avatar}`} alt="DJ Profile Avatar" className="weeklydjs-avatar-img" /></Link>*/}
                          
                              {/*<img src="https://laravelui.spruko.com/velvet/build/assets/images/media/media-37.jpg" className="img-fluid rounded-start h-100 w-100" alt="..." />*/}

                              <VideoPlayer
                                id="video"
                                //service={this.state.service.id} //{this.state.select.address}
                                //select={this.state.select_temp.select}
                                //uid={this.state.stage.live?.uid}
                                theatre={()=>{}}
                                onError={()=>{}}
                                height={100}
                                url={`https://${e.subdomain}${f.filename}?d=${Math.floor(Date.now()/1000)}`}
                                controls={true}
                                muted={false}
                                autoPlay={false}
                              />
                            
                          
                        </div>
                        <Row className="home-nl-bottom gx-0">
                          
                        </Row>
                      </SwiperSlide>
                    )
                  })}
                </Swiper>
                <div className="swiper-footer">

                </div>
              
            </div>
          
        </div>
      )
    });
    
		return (
			<>
        {this.state.portable === false &&
          <div className="d-sm-flex d-block align-items-center justify-content-between page-header-breadcrumb">
            <h4 className="fw-medium mb-0">Profile</h4>
            <div className="ms-sm-1 ms-0">
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item"><Link to={`/profile`}>Profile</Link></li>
                  <li className="breadcrumb-item active" aria-current="page">Dashboard</li>
                </ol>
              </nav>
            </div>
          </div>
        }
				{this.state.status === true &&
					<div className={`main-content ${this.state.portable===false&&'app-content'}`}>
						<div className="container-fluid">
    
              <div className="row">
                <div className="col-xxl-12 col-xl-12">
                  <div className="card custom-card overflow-hidden">
                    <div className="card-body d-sm-flex align-items-top p-4   main-profile-cover">
                      <p className="avatar avatar-xxl avatar-rounded online me-3 my-auto">
                        {(user.user?.user?.id === this.state.account.id && this.state.portable===false) ?
                          <UploadFile src={user.user.user.avatar.replace('/images/','')} path={`profile/${user.user.user.id}/`} onChange={this.changeAvatar}/>
                        :
                          <img src={`https://cloud.ultrastream.io${this.state.account.avatar}`} width="100%" alt="Avatar" />
                        }
                      </p>
                      <div className="flex-fill main-profile-info my-auto">
                        <h5 className="fw-semibold mb-1 ">
                          {this.state.account.title?this.state.account.title:this.state.account.username}
                        </h5>
                        <div>
                          {this.state.account.radios &&
                            <p className="mb-1 text-muted">{this.state.account.radios}</p>
                          }
                          {this.state.account.country &&
                            <div className="fs-12 op-7 mb-0 d-flex">
                                {typeof this.state.account.country === "string" ?
                                <p className="me-3 mb-0"><FontAwesomeIcon icon="building" /> {this.state.account.country}</p>
                                :
                                <>
                                    <p className="me-3 mb-0"><FontAwesomeIcon icon="building" /> {this.state.account.country[1]}</p>
                                    <p className="mb-0"><FontAwesomeIcon icon="location-dot" /> {this.state.account.country[0]}</p>
                                </>
                                }
                            </div>
                          }
                        </div>
                      </div>
                      <div className="main-profile-info ms-auto">
                        <div className="">
                          <div className="d-flex align-items-center justify-content-between">
                            <div className="d-flex mb-0 ms-auto">
                              <div className="me-4">
                                <p className="fw-bold fs-20  text-shadow mb-0">{this.state.friends}</p>
                                <p className="mb-0 fs-12 text-muted ">Followers</p>
                              </div>
                              <div className="">
                                <p className="fw-bold fs-20  text-shadow mb-0">{this.state.followers}</p>
                                <p className="mb-0 fs-12 text-muted ">Following</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="mb-0  mt-2 text-end">
                          {/*(this.state.portable=== false && (user.user.admin || user.user.user.id === this.state.account.id)) &&
                            <><Link to={user.user.admin?`/settings/${this.state.account.username}`:'/settings'}><button type="button" className="btn btn-primary btn-sm btn-wave waves-effect waves-light"><FontAwesomeIcon icon="gear" /> Settings</button></Link>&nbsp;</>
                          }
                          <button type="button" className="btn btn-secondary btn-sm btn-wave waves-effect waves-light"><FontAwesomeIcon icon="plus" /> Follow</button>*/}
                          <PortalFollwers uid={this.state.account.id} username={this.state.account.username} returnFollowers={this.returnFollowers} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xxl-3 col-xs-12 col-md-3">
                  <div className="card custom-card">
                    <div className="">
                      {profile_percent < 100 &&
                        <div className="p-4 border-bottom border-block-end-dashed">
                          <div>
                            <p className="fs-15 mb-2 fw-semibold">Profile Status :</p>
                            <p className="fw-semibold mb-2">Profile {profile_percent}% completed - <Link to="/settings" className="text-primary fs-12">Finish now</Link></p>
                            <div className="progress progress-sm progress-animate ">
                              <div className="progress-bar bg-primary  ronded-1" role="progressbar" aria-valuenow={this.state.account.profile} aria-valuemin="0" aria-valuemax="100" style={{width: `${this.state.account.profile}%`}}></div>
                            </div>
                          </div>
                        </div>
                      }
                      {this.state.account.description &&
                        <div className="p-4 border-bottom border-block-end-dashed">
                          <div className="">
                            <p className="fs-15 mb-2 fw-semibold">Professional Bio :</p>
                            <Blocks blocks={this.state.account.description} />
                          </div>
                        </div>
                      }
                      <div className="p-4  border-bottom border-block-end-dashed">
                        <p className="fs-15 mb-2 me-4 fw-semibold">Personal Info :</p>
                        <ul className="list-group">
                          {this.state.account.fullname &&
                            <li className="list-group-item border-0">
                              <div className="d-flex flex-wrap align-items-center">
                                <div className="me-2 fw-semibold"> Name : </div> <span className="fs-12 text-muted">{this.state.account.fullname}</span>
                              </div>
                            </li>
                          }
                          <li className="list-group-item border-0">
                            <div className="d-flex flex-wrap align-items-center">
                              <div className="me-2 fw-semibold"> Joined : </div> <span className="fs-12 text-muted">{moment(this.state.account.joined).format("Do MMM YYYY")}</span>
                            </div>
                          </li>
                          <li className="list-group-item border-0">
                            <div className="d-flex flex-wrap align-items-center">
                              <div className="me-2 fw-semibold"> Online : </div> <span className="fs-12 text-muted">{moment(this.state.account.lastconnect).format("Do MMM YYYY")}</span>
                            </div>
                          </li>
                          {/*<li className="list-group-item border-0">
                            <div className="d-flex flex-wrap align-items-center">
                              <div className="me-2 fw-semibold"> Designation : </div> <span className="fs-12 text-muted">C.E.O</span>
                            </div>
                          </li>
                          <li className="list-group-item border-0">
                            <div className="d-flex flex-wrap align-items-center">
                              <div className="me-2 fw-semibold"> Age : </div> <span className="fs-12 text-muted">28</span>
                            </div>
                          </li>
                          <li className="list-group-item border-0">
                            <div className="d-flex flex-wrap align-items-center">
                              <div className="me-2 fw-semibold"> Experience : </div> <span className="fs-12 text-muted">10 Years</span>
                            </div>
                          </li>*/}
                        </ul>
                      </div>
                      {this.state.account.genres &&
                        <div className="p-4 border-bottom border-block-end-dashed">
                            <p className="fs-15 mb-2 me-4 fw-semibold">Genres :</p>
                            <Genres genres={this.state.account.genres} />
                        </div>
                      }
                      <div className="p-4 border-bottom border-block-end-dashed">
                          <p className="fs-15 mb-2 me-4 fw-semibold">Social Networks :</p>
                          <div className="btn-list mb-0">
                            {Object.keys(this.state.account).length>0&&<Socials user={this.state.account} />}
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xxl-9 col-xs-12 col-md-9">
                  <div className="row">
                    <div className="col-xl-12">
                      <div className=" custom-card">
                        <div className="card-body p-0">
                          <div className="border-block-end-dashed  bg-white rounded-2 p-2">
                            <div>
                              <ul className="nav nav-pills nav-justified gx-3 tab-style-6 d-sm-flex d-block " id="myTab" role="tablist">
                                <li className="nav-item rounded" role="presentation">
                                  <button className="nav-link active" id="activity-tab" data-bs-toggle="tab" data-bs-target="#activity-tab-pane" type="button" role="tab" aria-controls="activity-tab-pane" aria-selected="true"><i className="ri-gift-line me-1 align-middle d-inline-block fs-16"></i>Activity</button>
                                </li>
                                {/*<li className="nav-item rounded" role="presentation">
                                  <button className="nav-link" id="gallery-tab" data-bs-toggle="tab" data-bs-target="#gallery-tab-pane" type="button" role="tab" aria-controls="gallery-tab-pane" aria-selected="false" tabIndex="-1"><i className="ri-exchange-box-line me-1 align-middle d-inline-block fs-16"></i>Gallery</button>
                                </li>
                                <li className="nav-item rounded" role="presentation">
                                  <button className="nav-link" id="posts-tab" data-bs-toggle="tab" data-bs-target="#posts-tab-pane" type="button" role="tab" aria-controls="posts-tab-pane" aria-selected="false" tabIndex="-1"><i className="ri-bill-line me-1 align-middle d-inline-block fs-16"></i>Projects</button>
                                </li>*/}
                                <li className="nav-item rounded" role="presentation">
                                  <button className="nav-link" id="followers-tab" data-bs-toggle="tab" data-bs-target="#followers-tab-pane" type="button" role="tab" aria-controls="followers-tab-pane" aria-selected="false" tabIndex="-1"><i className="ri-money-dollar-box-line me-1 align-middle d-inline-block fs-16"></i>Followers</button>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div className="py-4">
                            <div className="tab-content" id="myTabContent">
                              <div className="tab-pane show active fade p-0 border-0 p-0 rounded-3" id="activity-tab-pane" role="tabpanel" aria-labelledby="activity-tab" tabIndex="0">

                                {schedule}

                                {published}

                                <ul className="list-unstyled profile-timeline">
                                  
                                  <li> <span className="fs-12 text-muted fw-semibold text-end profile-timeline-time">22,Jan 2025</span>
                                    <div> <span className="avatar avatar-sm avatar-rounded profile-timeline-avatar"> <img src="../assets/images/faces/1.jpg" alt="" /> </span>
                                      <p className="text-muted mb-2"> <span className="text-default"><b>{this.state.account.title?this.state.account.title:this.state.account.username}</b> Shared project</span> </p>
                                      <p className="text-muted fs-12 mb-0">History of shows played will be listed here <br />
                                      This page not complete and please check back later{/*<strong>docfile.doc</strong>*/}</p>
                                      {/*<div className="btn-group file-attach mt-3" role="group" aria-label="Basic example"> <button type="button" className="btn btn-sm btn-primary-light"> <span className="ri-file-line me-2"></span> Image_file.jpg </button> <button type="button" className="btn btn-sm btn-primary-light" aria-label="Close"> <span className="ri-download-2-line"></span> </button></div>*/}
                                    
                                    </div>
                                  </li>
                                  
                                </ul>
                              </div>
                              
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
					</div>
				}
			</>
		);
	}
}

const Profile = props => {
  const { username } = useParams();
  return <PortalProfile username={username} {...props} />
}
export default Profile;